import restService from "../rest-service/RestService";
import { IRecipientEditDTO, IRecipientReferenceDTO, IRecipientUsageDTO } from "./Models";

const RecipientService = {

    getReferenceData: async function (groupID: number,
        organizationID: number,
        signal?: AbortSignal
    ) : Promise<IRecipientReferenceDTO> {

        const path = `/groups/${groupID}/organizations/${organizationID}/recipients/referenceData`;

        const response = await restService.get<IRecipientReferenceDTO>(path, signal);
        return response.data;
    },

    getRecipientUsage: async function (
        groupId: number,
        recipientId: number,
        signal?: AbortSignal
    ): Promise<Array<IRecipientUsageDTO>> {

        const path = `groups/${groupId}/recipients/${recipientId}/usage`;

        const response = await restService.get<Array<IRecipientUsageDTO>>(
            path,
            signal
        );

        return response.data;
    },

    checkRecipient: async function (
        groupId: number,
        recipient: IRecipientEditDTO, 
        signal?: AbortSignal
    ): Promise<IRecipientEditDTO> {

        const path = `groups/${groupId}/recipients/check`;

        const response = await restService.put<IRecipientEditDTO, IRecipientEditDTO>(
            path,
            recipient,
            signal
        );

        return response.data;
    },

    saveRecipient: async function(groupID: number, organizationID: number, recipient: IRecipientEditDTO): Promise<IRecipientEditDTO> {
        
        const path = `groups/${groupID}/organizations/${organizationID}/recipients`;

        const response = await restService.put<IRecipientEditDTO, IRecipientEditDTO>(
            path,
            recipient
        );

        return response.data;
    },

    saveRecipients: async function(groupID: number, organizationID: number, recipients: IRecipientEditDTO[]): Promise<IRecipientEditDTO[]> {
        
        const path = `groups/${groupID}/organizations/${organizationID}/recipientList`;

        const response = await restService.put<IRecipientEditDTO[], IRecipientEditDTO[]>(
            path,
            recipients
        );

        return response.data;
    }



};

export default RecipientService;